import { render, staticRenderFns } from "./CustomerFormModal.vue?vue&type=template&id=6f138a92&scoped=true"
import script from "./CustomerFormModal.vue?vue&type=script&lang=js"
export * from "./CustomerFormModal.vue?vue&type=script&lang=js"
import style0 from "./CustomerFormModal.vue?vue&type=style&index=0&id=6f138a92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f138a92",
  null
  
)

export default component.exports